import React, { createContext } from 'react'
import { useKeycloak } from '@react-keycloak/web'
import { useIntl } from 'react-intl'
import { NamedRoutes } from './routes'
import { useHistory } from 'react-router-dom'
import SubscriptionServices from './Services/Consumers/SubscriptionServices'

const CategoryContext = createContext({})

const CategoryProvider = ({ children, pageAction, cid, handleNotificationCall }) => {
  const { keycloak } = useKeycloak()
  const intl = useIntl()
  const history = useHistory()
  const [deleteCategoryLoading, setDeleteCategoryLoading] = React.useState(false)
  const [categoryDataLoading, setCategoryDataLoading] = React.useState(false)
  const [categoryDataFailure, setCategoryDataFailure] = React.useState(false)
  const [categoryData, setCategoryData] = React.useState({})

  React.useEffect(() => {
      if (!!cid && !!parseInt(cid)) {
        getCategoryData()
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const getCategoryData = () => {
    if (!!keycloak?.authenticated) {
      setCategoryDataFailure(false)
      setCategoryDataLoading(true)
      SubscriptionServices.getCategoryData(cid, { headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` } }).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          setCategoryDataFailure(true)
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            setCategoryData(result.data.data)
          } else {
            setCategoryDataFailure(true)
          }
        }
      }).then(() => {
        setCategoryDataLoading(false)
      })
    }
  }

  const handleCategorySubmit = (values, FormikActions) => {
    if (!!keycloak?.authenticated) {
      FormikActions.setSubmitting(true)
      SubscriptionServices.submitCategory(cid, pageAction === 'edit', values, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, FormikActions.setSubmitting, null, FormikActions).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
          if (result.response.data && result.response.data.status && result.response.data.status.errors) {
            message = result.response.data.status.errors
          }
          handleNotificationCall({
            type: 'defence',
            message: message,
            color: 'error'
          }, 'error')
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: pageAction === 'edit' ? 'Category.Edit.FormSuccessAlert' : 'Category.Add.FormSuccessAlert' }),
              color: 'success'
            }, 'success')
            history.push(NamedRoutes.subscription.category.list)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
          }
        }
      }).then(() => {
        FormikActions.setSubmitting(false)
      })
    }
  }

  const handleDeleteCategory = (index, data, setData, count, setCount, handleDeleteCategoryDialog) => {
    if (!!keycloak?.authenticated) {
      setDeleteCategoryLoading(true)
      SubscriptionServices.deleteCategory(data[index].id, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, setDeleteCategoryLoading).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
            color: 'error'
          }, 'error')
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({ id: 'Category.Delete.FormSuccessAlert' }),
              color: 'success'
            }, 'success')
            let newData = data
            newData.splice(index, 1)
            setData(newData)
            setCount(--count)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
          }
        }
      }).then(() => {
        setDeleteCategoryLoading(false)
        handleDeleteCategoryDialog()
      })
    }
  }

  return (
    <CategoryContext.Provider value={{
      categoryDataLoading: categoryDataLoading,
      categoryDataFailure: categoryDataFailure,
      categoryData: categoryData,
      pageAction: pageAction,

      handleCategorySubmit,

      deleteCategoryLoading: deleteCategoryLoading,
      handleDeleteCategory
    }}>
      {children}
    </CategoryContext.Provider>
  )
}
const CategoryConsumer = CategoryContext.Consumer

export { CategoryProvider, CategoryConsumer }
